import { APIResource } from 'services'
import { JSONApiResourceDecorator } from 'utils'
import { ProtectResourceDecorator } from 'services/TokenStore'

export const ProtectedJsonAPI = new APIResource('',{},{ decorators: [ProtectResourceDecorator, JSONApiResourceDecorator]})